module.exports = __webpack_public_path__ + "static/media/logo-color.85fd2ee3.svg";